import { Component, OnInit, OnDestroy } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { WeGoConfig, IAPIResponse } from "../../shared/config";
import { Observable } from "rxjs/Observable";
import { TranslateService } from "../../shared/translate/index";

@Component({
  selector: "admin-invitation-reject",
  template: `
  <section class="content">
		<div class="col-md-12 text-center">
      <div class="panel panel-danger">
      <div class="panel-heading">
      {{ 'LblInvitationReject' | translate }}
      </div>
      <div class="panel-body">
      <p>
      <span>{{ 'LblThankYouForConfirmation' | translate }}</span><br>
      <span> {{ 'LblPleaseClick' | translate }} </span> <a routerLink="/">{{ 'LblHere' | translate }}</a>
      <span> {{ 'LblGoToHome' | translate }}</span>
      </p>
      </div>
    </div>
         
		</div>
  </section>
  `,
  styles: [
    `.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`
  ]
})
export class AdminInvitationRejectComponent implements OnInit, OnDestroy {
  constructor(private translate: TranslateService) {}
  ngOnInit() {}
  ngOnDestroy() {
    console.log("ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-invitation/components/admin-invitation-reject.component.ts